import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ddmmyyyy } from '../../../helpers/ddmmyyyy'
import { getScore } from '../../../helpers/getScore'
import { questions } from '../../../utils/constants'

const SurveyItem = ({ survey, therapist }) => {

    const navigate = useNavigate()
    let totalScore = 0
    questions.forEach((s, id) => {
        if (id != 0) {
            totalScore += getScore(id, survey?.answers[(id + 1).toString()])
        }
    })
    return (
        <div style={{
            // height: 50,
            width: '80%',
            marginBottom: 10,
            border: '1px solid black',
            padding: 10,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'

        }}
            onClick={() => navigate('/survey_details', { state: { survey, therapist } })}
        >
            <h3>{ddmmyyyy(survey.timestamp.toDate())}</h3>
            <div
                style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
            >
                <p style={{fontSize:25}} >{totalScore}</p>
            </div>
        </div>
    )
}

export default SurveyItem